<template>
    <div class="flex items-center gap-2">
        <v-btn v-if="item.note?.called == 1" text @click="$emit('openModal', item)">
            <div class="flex items-center gap-1 text-teal">
                <v-icon color="teal">mdi-phone-check</v-icon>
                <span>{{ item.note.called_user.replace(/ .*/, '') }}</span>
            </div>
            <p v-if="item.note.called_date" class="text-sm">{{ item.note.called_date | formatDate }} <span
                    v-if="user.rol == 'admin' || user.rol == 'superuser'">{{ item.note.called_date |
                        formatTime }}</span></p>
        </v-btn>
        <v-btn v-else text @click="$emit('openModal', item)">
            <v-icon color="grey" dark>
                mdi-phone-outgoing
            </v-icon>
            <span class="font-semibold px-2">Sunat?</span>
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        item: Object,
        user: Object,
    }
}
</script>